(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/account/register', {}, {});
    }
})();
